import { route } from "../../service/routeDictionary";
import API from "../../service/api";
import { environment } from "../../environments/env";

const state = {};

const getters = {};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async getStore({ commit }, data) {
    if (data.isByName) {
      return await API.get(
        `${environment.apiUri}${route.InstagramPage}?pageName=${data.storeName}&Limit=5&Offset=0&Sort=+ID`
      );
    } else {
      return await API.get(
        `${environment.apiUri}${route.InstagramPage}?Limit=5`
      );
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getStoresByPagination({ commit }, data) {
    if (data.id != undefined) {
      return await API.get(
        `${environment.apiUri}${route.InstagramPage}?instaPageId=${data.id}&Limit=${data.limit}&Offset=${data.offset}&Sort=+ID`
      );
    } else if (!(data.name.length > 0)) {
      return await API.get(
        `${environment.apiUri}${route.InstagramPage}?Limit=${data.limit}&Offset=${data.offset}&Sort=+ID`
      );
    } else if (data.name.length > 0) {
      return await API.get(
        `${environment.apiUri}${route.InstagramPage}?pageName=${data.name}&Limit=${data.limit}&Offset=${data.offset}&Sort=+ID`
      );
    }
  },

  async getStoresByRegional() {
    return await API.get(`${environment.apiUri}${route.GetRegional}`);
  },

  async getInstagramRelationship({ commit }, data) {
    if (data.id != undefined) {
      return await API.get(
        `${environment.apiUri}${route.GetRelationship}?instaPageId=${data.id}&Limit=${data.limit}&Offset=${data.offset}&Sort=+ID`
      );
    } else if (!(data.name.length > 0)) {
      return await API.get(
        `${environment.apiUri}${route.GetRelationship}?Limit=${data.limit}&Offset=${data.offset}&Sort=+ID`
      );
    } else if (data.name.length > 0) {
      return await API.get(
        `${environment.apiUri}${route.GetRelationship}?pageName=${data.name}&Limit=${data.limit}&Offset=${data.offset}&Sort=+ID`
      );
    }
  },
};

const mutations = {};

export default {
  state,
  actions,
  getters,
  mutations,
};
